// routePermissions.js
import { ROUTES } from "../constant";
import { MENU_LABELS } from "../constant/Menu_Labels";

export const routePermissions = [
  // ===========================
  // Dashboard
  // ===========================
  { path: ROUTES.HOME, value: MENU_LABELS.DASHBOARD.value },

  // ===========================
  // Classes
  // ===========================
  { path: ROUTES.CLASSES.BASE, value: MENU_LABELS.CLASSES.value },
  { path: ROUTES.CLASSES.ADD, value: MENU_LABELS.CLASSES.value },
  { path: ROUTES.CLASSES.EDIT, value: MENU_LABELS.CLASSES.value },

  // ===========================
  // Questions
  // ===========================
  { path: ROUTES.QUESTIONS.BASE, value: MENU_LABELS.QUESTIONS.value },
  { path: ROUTES.QUESTIONS.COPY, value: MENU_LABELS.COPY_QUESTIONS.value },
  { path: ROUTES.QUESTIONS.SUBJECT, value: MENU_LABELS.SUBJECTS_SUBTOPICS.value },

  // ===========================
  // Courses
  // ===========================
  { path: ROUTES.COURSES.BASE, value: MENU_LABELS.ALL_COURSES.value },
  { path: ROUTES.COURSES.ADD, value: MENU_LABELS.ALL_COURSES.value },
  { path: ROUTES.COURSES.EDIT, value: MENU_LABELS.ALL_COURSES.value },
  { path: ROUTES.COURSES.MODULE, value: MENU_LABELS.MODULE.value },
  { path: ROUTES.COURSES.MODULE_ADD_EDIT, value: MENU_LABELS.MODULE.value },
  { path: ROUTES.COURSES.LECTURES, value: MENU_LABELS.COURSE_LECTURES.value },
  { path: ROUTES.COURSES.LECTURES_MODULE, value: MENU_LABELS.COURSE_LECTURES.value },
  { path: ROUTES.COURSES.LECTURES_MODULE_ADD_EDIT, value: MENU_LABELS.COURSE_LECTURES.value },
  { path: ROUTES.COURSES.PURCHASE, value: MENU_LABELS.COURSE_PURCHASE.value },
  { path: ROUTES.COURSES.PURCHASE_EDIT, value: MENU_LABELS.COURSE_PURCHASE.value },
  { path: ROUTES.COURSES.FAQ, value: MENU_LABELS.COURSE_FAQ.value },
  { path: ROUTES.COURSES.FAQ_ADD_EDIT, value: MENU_LABELS.COURSE_FAQ.value },

  // ===========================
  // Workshops
  // ===========================
  { path: ROUTES.WORKSHOPS.BASE, value: MENU_LABELS.ALL_WORKSHOPS.value },
  { path: ROUTES.WORKSHOPS.WORKSHOP_ADD_EDIT, value: MENU_LABELS.ALL_WORKSHOPS.value },
  { path: ROUTES.WORKSHOPS.REGISTER, value: MENU_LABELS.WORKSHOP_REGISTER.value },
  { path: ROUTES.WORKSHOPS.REGISTER_EDIT, value: MENU_LABELS.WORKSHOP_REGISTER.value },
  { path: ROUTES.WORKSHOPS.LECTURES, value: MENU_LABELS.WORKSHOP_LECTURES.value },
  { path: ROUTES.WORKSHOPS.LECTURES_ADD_EDIT, value: MENU_LABELS.WORKSHOP_LECTURES.value },
  { path: ROUTES.WORKSHOPS.TESTIMONIALS, value: MENU_LABELS.WORKSHOP_TESTIMONIALS.value },
  { path: ROUTES.WORKSHOPS.TESTIMONIALS_ADD_EDIT, value: MENU_LABELS.WORKSHOP_TESTIMONIALS.value },
  { path: ROUTES.WORKSHOPS.FAQ, value: MENU_LABELS.WORKSHOP_FAQ.value },
  { path: ROUTES.WORKSHOPS.FAQ_ADD_EDIT, value: MENU_LABELS.WORKSHOP_FAQ.value },

  // ===========================
  // Contest
  // ===========================
  { path: ROUTES.CONTEST.BASE, value: MENU_LABELS.ALL_CONTESTS.value },
  { path: ROUTES.CONTEST.ADD, value: MENU_LABELS.ALL_CONTESTS.value },
  { path: ROUTES.CONTEST.EDIT, value: MENU_LABELS.ALL_CONTESTS.value },
  { path: ROUTES.CONTEST.TYPE, value: MENU_LABELS.CONTEST_TYPES.value },
  { path: ROUTES.CONTEST.LEADERBOARD, value: MENU_LABELS.ALL_CONTESTS.value },

  // ===========================
  // Reports
  // ===========================
  { path: ROUTES.REPORTS.USER, value: MENU_LABELS.USER_REPORT.value },
  { path: ROUTES.REPORTS.QUESTION, value: MENU_LABELS.QUESTIONS_REPORT.value },
  { path: ROUTES.REPORTS.RESULT, value: MENU_LABELS.RESULT_REPORT.value },

  // ===========================
  // Earnings
  // ===========================
  { path: ROUTES.EARNINGS.CONTEST_WISE, value: MENU_LABELS.CONTEST_WISE_EARNING.value },
  { path: ROUTES.EARNINGS.SUBJECT_WISE, value: MENU_LABELS.SUBJECT_WISE_EARNING.value },
  { path: ROUTES.EARNINGS.SLOT_TIME, value: MENU_LABELS.SLOT_TIME_EARNING.value },
  { path: ROUTES.EARNINGS.USER, value: MENU_LABELS.USER_EARNING.value },
  { path: ROUTES.EARNINGS.CLASSES, value: MENU_LABELS.CLASSES_EARNING.value },

  // ===========================
  // Users
  // ===========================
  { path: ROUTES.USERS.BASE, value: MENU_LABELS.ALL_USERS.value },
  { path: ROUTES.USERS.ADD, value: MENU_LABELS.ADD_NEW_USER.value },
  { path: ROUTES.USERS.EDIT, value: MENU_LABELS.ADD_NEW_USER.value },
  { path: ROUTES.USERS.DETAIL, value: MENU_LABELS.USERDATA.value },
  { path: ROUTES.USERS.KYC, value: MENU_LABELS.KYC_VERIFICATION.value },

  // ===========================
  // Website Pages
  // ===========================
  { path: ROUTES.WEBSITE.INTERFACE, value: MENU_LABELS.INTERFACE.value },
  { path: ROUTES.WEBSITE.INTERFACE_ADD_EDIT, value: MENU_LABELS.INTERFACE.value },

  { path: ROUTES.WEBSITE.FEATURES, value: MENU_LABELS.FEATURES.value },
  { path: ROUTES.WEBSITE.FEATURES_ADD_EDIT, value: MENU_LABELS.FEATURES.value },

  { path: ROUTES.WEBSITE.HOW_IT_WORKS, value: MENU_LABELS.HOW_IT_WORKS.value },
  { path: ROUTES.WEBSITE.HOW_IT_WORKS_ADD_EDIT, value: MENU_LABELS.HOW_IT_WORKS.value },

  { path: ROUTES.WEBSITE.FAQ, value: MENU_LABELS.FAQ.value },
  { path: ROUTES.WEBSITE.FAQ_ADD_EDIT, value: MENU_LABELS.FAQ.value },

  { path: ROUTES.WEBSITE.TRUSTED_BY, value: MENU_LABELS.TRUSTED_BY.value },
  { path: ROUTES.WEBSITE.TRUSTED_BY_ADD, value: MENU_LABELS.TRUSTED_BY.value },
  { path: ROUTES.WEBSITE.TRUSTED_BY_EDIT, value: MENU_LABELS.TRUSTED_BY.value },

  { path: ROUTES.WEBSITE.BANNER, value: MENU_LABELS.BANNERS.value },

  { path: ROUTES.WEBSITE.BLOG, value: MENU_LABELS.BLOG.value },
  { path: ROUTES.WEBSITE.BLOG_ADD, value: MENU_LABELS.BLOG.value },
  { path: ROUTES.WEBSITE.BLOG_EDIT, value: MENU_LABELS.BLOG.value },

  { path: ROUTES.WEBSITE.CONTACT_ENQUIRIES, value: MENU_LABELS.CONTACT_ENQUIRIES.value },
  { path: ROUTES.WEBSITE.CONTACT_ENQUIRIES_ADD, value: MENU_LABELS.CONTACT_ENQUIRIES.value },
  { path: ROUTES.WEBSITE.CONTACT_ENQUIRIES_EDIT, value: MENU_LABELS.CONTACT_ENQUIRIES.value },

  { path: ROUTES.WEBSITE.ABOUT_US, value: MENU_LABELS.ABOUT_US.value },
  { path: ROUTES.WEBSITE.PRIVACY_POLICY, value: MENU_LABELS.PRIVACY_POLICY.value },
  { path: ROUTES.WEBSITE.TERMS_CONDITION, value: MENU_LABELS.TERMS_CONDITIONS.value },
  { path: ROUTES.WEBSITE.LEGALITY, value: MENU_LABELS.LEGALITY.value },

  // ===========================
  // Finance
  // ===========================
  { path: ROUTES.FINANCE.INCOME_EXPENSE, value: MENU_LABELS.INCOME_EXPENSE.value },
  { path: ROUTES.FINANCE.WITHDRAWAL, value: MENU_LABELS.WITHDRAWAL.value },
  { path: ROUTES.FINANCE.WITHDRAWAL_REQUEST, value: MENU_LABELS.WITHDRAWAL_REQUEST.value },
  { path: ROUTES.FINANCE.REFUND_POLICY, value: MENU_LABELS.REFUND_POLICY.value },

  // ===========================
  // Settings
  // ===========================
  { path: ROUTES.COUPON.BASE, value: MENU_LABELS.COUPON_CODE.value },
  { path: ROUTES.COUPON.ADD_EDIT, value: MENU_LABELS.COUPON_CODE.value },

  { path: ROUTES.MOCK_TEST_DISCOUNT, value: MENU_LABELS.MOCK_TEST_DISCOUNT.value },
  { path: ROUTES.FREE_MOCK_TEST, value: MENU_LABELS.FREE_MOCK_TEST.value },
  { path: ROUTES.SETTINGS, value: MENU_LABELS.SETTING.value },
  { path: ROUTES.PAYMENT_MESSAGE, value: MENU_LABELS.PAYMENT_MESSAGE.value },


  // ===========================
  // Misc
  // ===========================
  { path: ROUTES.EXAM_TYPE, value: MENU_LABELS.EXAM_TYPES.value },
  { path: ROUTES.GOAL, value: MENU_LABELS.GOAL_TYPES.value },

  // ===========================
  // Social / YouTube
  // ===========================
  { path: ROUTES.YOUTUBE_VISUALS, value: MENU_LABELS.YOUTUBE_VISUALS.value },
  { path: ROUTES.SOCIAL_MEDIA_ENGAGE, value: MENU_LABELS.SOCIAL_MEDIA_ENGAGE.value },

  // ===========================
  // User Admin
  // ===========================
  { path: ROUTES.USER_ADMIN.BASE, value: MENU_LABELS.USER_ADMIN.value },
  { path: ROUTES.USER_ADMIN.ADD_EDIT, value: MENU_LABELS.USER_ADMIN.value },
];
